import React from "react";
import { Flex, Text, Icon, Link } from "@chakra-ui/react";
import {
  FaPhone,
  FaEnvelope,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa6";

const socials = [
  {
    name: "Phone",
    url: "tel:+254717431706",
    icon: FaPhone,

    content: "+254717431706",
  },
  {
    name: "Email",
    url: "mailto:shazzynyambu@gmail.com",
    icon: FaEnvelope,
    content: "shazzynyambu@gmail.com",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/sharon-nyambura-07058a226/",
    icon: FaLinkedinIn,
    content: "Sharon Nyambura",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/callmeshazzy?igsh=MTFrZHZocjdhejNveA==",
    icon: FaInstagram,
    content: "@callmeshazzy",
  },
];
const Socials = () => {
  return (
    <>
      {socials.map((social, i) => {
        return (
          <Flex alignItems="center" gap={5} mb={5} key={i}>
            <Link href={social.url} isExternal mx="2">
              <Icon as={social.icon} boxSize="7" />
            </Link>
            <Text>{social.content}</Text>
          </Flex>
        );
      })}
    </>
  );
};

export default Socials;
